export default (Alpine) => {
    Alpine.data('signupFormVipDrop', () => ({
      modal: null,
      finePrint: null,
  
      init() {
        this.finePrint = this.$refs.finePrint

        window.addEventListener('klaviyoForms', (e) => {
            if (e.detail.type === 'submit') {
              this.finePrint.classList.add('hidden')
            }
        })
      },

    }))
  }